exports.f = Object.getOwnPropertySymbols;



//////////////////
// WEBPACK FOOTER
// ../~/core-js/modules/_object-gops.js
// module id = 131
// module chunks = 2